export const getShortTermLiquidityOutcome = (
  assets: number | undefined,
  liabilities: number | undefined
) => {
  const liquidityValue =
    typeof assets !== 'undefined' &&
    typeof liabilities !== 'undefined' &&
    liabilities > 0
      ? assets / liabilities
      : undefined;
  if (typeof liquidityValue === 'undefined') return 'n/a';
  return liquidityValue >= 1 ? 'Good' : 'Low';
};
